export interface RecipeState {
  id: string;
  metadata: {
    active: boolean;
    author: string;
    categories: string[];
    tags: string[];
    cookTime: number;
    description: string;
    editor: string;
    lastEditedAt: string;
    maxServing: number;
    minServing: number;
    prepTime: number;
    url: string;
    name: string;
    createdSource: string;
    created_by: string;
    is_deleted: boolean;
    is_public: boolean;
    defaultVariationId: string;
  };
  steps: Array<{
    Rank: number;
    description: string;
    id: string;
    ingredientsTitle: string;
    name: string;
    priority: string;
    status?: string;
    subSteps: Array<{
      Rank: number;
      id: string;
      name: string;
      type: string;
      parameters: any;
      progress: string;
    }>;
  }>;
}

export interface RecipePageState {
  currentRecipeId?: string;
  allVideosMuted: boolean;
  recipe?: RecipeState;
  experience2View: string;
  currentActiveStepId?: string;
  loading: boolean;
  inFocusSubstepId?: string;
  runningData?: {
    currSubStepId?: string;
    currStep?: any;
  };
  servingSize: number;
  isViewRecipeOpen: boolean;
  substepEdit: {
    substepOperation: string | null;
    substepId: string | null;
    subStepUId: string | null;
  }
}

export const RecipeStepPriorities = {
  immediate: "immediate",
  deprioritised: "deprioritised",
};

export const RecipeStepProgressTypes = {
  completed: "completed",
  inProgress: "in-progress",
  paused: "paused",
  start: "start",
  notStarted: "not-started",
  pausedOnDisconnect: "paused-on-disconnect",
  skipped: "skipped",
};

export const TimerInstructions = [
  "cut",
  "saute",
  "cook",
  "mix",
  "boil",
  "roast",
  "clean",
  "Instructions_v2",
];

export const nonTimerInstruction = ["scrape", "strain"];
export const description = ["addIngredients", "addIngredientsWithAlternate"];
const extraPrep = ["setAside"];
export const imgUtility = ["imgUtility"];
const urlUtility = "urlUtility";
const criticalStep = "criticalStep";
const ratingCollector = "ratingCollector";

export const SubStepTypes = {
  urlUtility,
  criticalStep,
  ratingCollector,
  description: {
    addIngredients: "addIngredients",
    addIngredientsWithAlternate: "addIngredientsWithAlternate",
  },
  imgUtility: {
    imgUtility: "imgUtility",
  },
};

export const subStepTypesE3 = {
  ingredients: 'ingredients',
  instruction: 'instruction',
}

export const Experience2ViewTypes = {
  wide: "wide",
  default: "default",
};

export interface RatingSummaryQueryInterface {
  rating_avg: number | undefined;
  rating_count: number | undefined;
  top_feedback: string[] | undefined;
}

export interface RatingSummary {
  avgRating: number;
  ratingCount: number;
  feedbacks: string[];
}

export interface RecipeReviewInterface {
  rating: number;
  feedback: string[];
  sessionRecipe: {
    name: string;
  },
  startTime: string;
  user: {
    nickName: string;
    photoURL: string | undefined;
  },
  userComments: string;
}
